/**
 * Types of permissions.
 */
export enum EPermissions {
  CREATE = 'CREAR',
  VISUALIZE = 'VER',
  DISABLE = 'DESACTIVAR',
  MODIFY = 'MODIFICAR',
}
